<script setup lang="ts">
withDefaults(
  defineProps<{
    files?: any;
    header?: string;
    showTypeCol?: boolean;
    showVisibilityCol?: boolean;
  }>(),
  {
    header: 'components.fileUploader.header',
  }
);
</script>

<template>
  <div class="flex flex-col gap-3">
    <h2 class="text-base font-semibold">{{ $t(header) }}</h2>

    <div
      v-if="files?.length"
      class="flex justify-between gap-2 border-b font-medium"
    >
      <h3 class="max-w-72 text-sm">{{ $t('components.fileUploader.fileName') }}</h3>

      <h3
        v-if="showTypeCol"
        class="hidden max-w-72 text-sm sm:flex"
      >
        {{ $t('components.fileUploader.category') }}
      </h3>

      <h3
        v-if="showVisibilityCol"
        class="hidden max-w-72 text-sm sm:flex"
      >
        {{ $t('components.fileUploader.visibility') }}
      </h3>

      <h3 class="w-32 text-sm">{{ $t('components.fileUploader.date') }}</h3>
    </div>
  </div>
</template>
